/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { strategiesGetStrategyForecast } from "../../funcs/strategiesGetStrategyForecast.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetStrategyForecastRequest$inboundSchema,
};

export const tool$strategiesGetStrategyForecast: ToolDefinition<typeof args> = {
  name: "strategies-get-strategy-forecast",
  description: `Get forecasts for a strategy

Returns forecasts for a given strategy. The strategy's trajectories and horizons are used to generate forecasts identical to the POST /v1/assets/futures/forecasts/{symbol} endpoint.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await strategiesGetStrategyForecast(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
